import React, { useState, useRef } from "react";
import CloseRedIconSvg from "../../svg/CloseRedIconSvg";
import {
  AddProducts,
  EditeProducts,
  DeleteProducts,
  ListProducts,
  GetCampaign,
} from "../../services/services";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";
import TextField from "../../components/Textfield/TextField";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Dropdown } from "primereact/dropdown";
import ListCardAddNewGift from "./ListCardAddNewGift";
import ResponsiveDataList from "../../components/ResponsiveDataList/ResponsiveDataList";
import { editOffSvg } from "../../svg/editOff.svg";
import { editSvg } from "../../svg/edit.svg";
import { booleanFormatter } from "../../formatters/booleanFormatter";
import { Toast } from "primereact/toast";
import Loading from "../../components/Loading/Loading";
import { useResponsivePageSize } from "../../hook/useResponsivePageSize";

const AddNewGift = () => {
  const pageSize = useResponsivePageSize({
    defaultSmall: 10,
    defaultLarge: 10,
  });

  const [addGift, setAddGift] = useState({
    Id: undefined,
    Description: "",
    IsActive: true,
    Name: "",
    Picture: "",
    Price: "",
    productGuids: "",
    file: "",
    order: 1,
    CampaignId: undefined,
  });

  const [editingRowId, setEditingRowId] = useState(undefined);
  const [filters, setFilters] = useState({
    IsActive: true,
    pageSize: pageSize,
    pageNumber: 1,
  });

  const queryClient = useQueryClient();
  const toast = useRef(null);

  const showSubmit = () => {
    toast.current.show({
      severity: "success",
      summary: "انجام شد",
      detail: " درخواست با موفقیت انجام شد ",
      life: 3000,
    });
  };

  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "خطا",
      detail: " درخواست با مشکل رو به رو شد! ",
      life: 3000,
    });
  };

  const isActiveOptions = [
    { label: "فعال", value: true },
    { label: "غیرفعال", value: false },
  ];

  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setAddGift({
        ...addGift,
        file: file,
      });
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const { data: listGift } = useQuery({
    queryKey: ["ListProducts", filters],
    queryFn: () =>
      ListProducts({
        pageNumber: filters?.pageNumber,
        pageSize: filters?.pageSize,
        IsActive: filters?.IsActive,
      }),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
    enabled: true,
  });

  const { data: getCampaign } = useQuery({
    queryKey: ["GetCampaign", filters],
    queryFn: () => GetCampaign(),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
    enabled: true,
  });

  const campaignOptions = Array.isArray(getCampaign)
    ? getCampaign.map((item) => ({
        label: item?.title,
        value: item?.id,
      }))
    : [];

  const usedFilterOptions = [
    { label: " فعال ", value: true },
    { label: "  غیر فعال", value: false },
  ];

  const usedFilterTemplate = (options) => {
    const handleChange = (e) => {
      if (options && options.filterApplyCallback) {
        setFilters({ ...filters, IsActive: e.value });
      }
    };

    return (
      <div style={{ marginRight: "10px" }}>
        <Dropdown
          value={filters?.IsActive ?? null}
          options={usedFilterOptions}
          onChange={handleChange}
          optionLabel="label"
          optionValue="value"
          placeholder="انتخاب وضعیت"
          style={{
            height: "35px",
            paddingRight: "6px",
            display: "flex",
            alignItems: "center",
            boxShadow: "none",
          }}
        />
      </div>
    );
  };

  const handleEditClick = (rowData) => {
    setAddGift({
      Id: rowData.id,
      Name: rowData.name ?? "",
      Price: rowData.price ?? "",
      Description: rowData.description ?? "",
      IsActive: rowData.isActive ?? true,
      productGuids: rowData.productGuids?.[0] ?? "",
      file: null,
      Picture: rowData.urls?.[0] ?? "",
      order: 1,
    });

    setEditingRowId(rowData.id);
  };

  const columns = [
    {
      field: "name",
      header: "نام",
      style: { textAlign: "right" },
      body: (rowData) => rowData.name,
    },
    {
      header: "سکه",
      field: "price",
      style: { textAlign: "right" },
      sortable: true,
    },
    {
      field: "productCount",
      header: "تعداد  محصول",
      style: { textAlign: "right" },
      sortable: true,
    },
    {
      field: "isActive",
      header: "وضعیت",
      body: (rowData) => booleanFormatter(rowData.isActive),
      filter: true,
      showFilterMatchModes: false,
      filterElement: usedFilterTemplate,
      style: { textAlign: "right" },
    },
    {
      header: "لینک",
      body: (rowData) => (
        <div
          title={rowData.description}
          className="text-truncate"
          style={{
            maxWidth: "18rem",
            overflow: "hidden",
            whiteSpace: "nowrap",
            direction: "rtl",
            textAlign: "right",
          }}
        >
          {rowData.description}
        </div>
      ),
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => (
        <img
          src={rowData.urls[0]}
          width={40}
          className="rounded-circle border"
        />
      ),
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => {
        const handleToggleEdit = (rowData) => {
          if (editingRowId == rowData.id) {
            setEditingRowId(undefined);
            setAddGift({
              Id: undefined,
              Description: "",
              IsActive: true,
              Name: "",
              Picture: "",
            });
          } else {
            setEditingRowId(rowData.id);
            setAddGift({
              Id: rowData.id,
              Name: rowData.name,
              Price: rowData.price,
              Description: rowData.description,
              IsActive: rowData.isActive,
              productGuids: rowData.productGuids[0],
            });
          }
        };

        return (
          <div
            onClick={() => handleToggleEdit(rowData)}
            style={{ cursor: "pointer" }}
          >
            {editingRowId == rowData.id ? editOffSvg() : editSvg({ width: 15 })}
          </div>
        );
      },
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => (
        <div
          onClick={() =>
            DeleteProducts(rowData.id).then(
              () => queryClient.invalidateQueries(["StoreItems"]),
              showSubmit()
            )
          }
          style={{ cursor: "pointer" }}
        >
          <CloseRedIconSvg style={{ width: "20px", height: "20px" }} />
        </div>
      ),
      style: { textAlign: "right" },
    },
  ];

  const handleSave = () => {
    const payload = {
      Description: addGift.Description,
      IsActive: addGift.IsActive,
      Name: addGift.Name,
      Price: addGift.Price,
      Id: addGift.Id,
      Attachments: {
        id: addGift.productGuids,
        file: addGift.file || null,
        order: 1,
      },
    };

    if (editingRowId === undefined) {
      AddProducts({
        Description: payload?.Description,
        IsActive: payload?.IsActive,
        Name: addGift.Name,
        Price: addGift.Price,
        Attachments: {
          file: addGift.file || null,
          order: 1,
        },
        CurrencyId: 1,
        CategoryId: 1,
        CampaignId: addGift?.CampaignId ? addGift?.CampaignId : null,
      })
        .then(() => showSubmit())
        .catch(() => showError());
    } else {
      EditeProducts(payload)
        .then(() => {
          queryClient.invalidateQueries(["StoreItems"]);
          showSubmit();
        })
        .catch(() => showError());
    }
  };

  return (
    <div className="custom-container mt-3">
      <Toast ref={toast} />
      <div className="card">
        {editingRowId === undefined ? (
          <h5>افزودن هدیه</h5>
        ) : (
          <h5>ادیت مشخصات هدیه </h5>
        )}
        <div className="background-dataTable">
          <div className="row mt-3">
            <div className="col-12 col-sm-6 col-xl-2 mt-xl-0 mt-4">
              <TextField
                style={{ height: "40px" }}
                value={addGift.Name}
                label={"نام هدیه"}
                onChange={(e) =>
                  setAddGift({ ...addGift, Name: e.target.value })
                }
              />
            </div>
            <div className="col-12 col-sm-6 col-xl-2 mt-xl-0 mt-4">
              <TextField
                style={{ height: "40px" }}
                value={addGift.Description}
                label={"لینک هدیه"}
                onChange={(e) =>
                  setAddGift({ ...addGift, Description: e.target.value })
                }
              />
            </div>

            <div className="col-12 col-sm-6 col-xl-2 mt-xl-0 mt-4">
              <TextField
                style={{ height: "40px" }}
                value={addGift.Price}
                label={"سکه"}
                onChange={(e) =>
                  setAddGift({ ...addGift, Price: e.target.value })
                }
              />
            </div>
            <div className="col-12 col-sm-6 col-xl-2 mt-xl-0 mt-4">
              <SelectCustom
                name="isActive"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={isActiveOptions}
                value={
                  isActiveOptions.find(
                    (item) => item.value === addGift.IsActive
                  ) || null
                }
                onChange={(e) => {
                  setAddGift({ ...addGift, IsActive: e ? e.value : null });
                }}
              />
            </div>
            {editingRowId === undefined && (
              <div className="col-12 col-sm-6 col-xl-2 mt-xl-0 mt-4">
                <SelectCustom
                  name="CampaignId"
                  placeholder="کمپین"
                  isClearable={true}
                  isSearchable={false}
                  unstyled={true}
                  options={campaignOptions}
                  value={
                    campaignOptions.find(
                      (item) => item.value === addGift.CampaignId
                    ) || null
                  }
                  onChange={(e) => {
                    setAddGift({
                      ...addGift,
                      CampaignId: e ? e.value : null,
                    });
                  }}
                />
              </div>
            )}

            <div className="col-12 col-sm-6 col-xl-2 mt-xl-0 mt-4 d-flex align-items-center">
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                capture="filesystem"
                style={{ display: "none" }}
              />
              <button
                type="button"
                onClick={handleButtonClick}
                style={{ height: "40px", width: "100%" }}
                className="button-upload-file"
              >
                <svg
                  style={{ width: "20px" }}
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="img-upload"
                >
                  <path
                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="text-button-upload-file">
                  {addGift.Picture === "" ? "آپلود عکس هدیه" : "عکس انتخاب شد"}
                </span>
              </button>
              {addGift.file && (
                <div className="position-relative">
                  <img
                    style={{
                      marginRight: "8px",
                      border: "1px solid #fff",
                      borderRadius: "12px",
                    }}
                    src={URL.createObjectURL(addGift.file)}
                    width={60}
                  />
                  <CloseRedIconSvg
                    onClick={() => {
                      setAddGift({ ...addGift, file: "" });
                    }}
                    style={{
                      cursor: "pointer",
                      width: "16px",
                      height: "16px",
                      position: "absolute",
                      left: "-8px",
                      top: "0px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              style={{
                color: "#ffff",
                background: "rgba(134, 160, 255, 0.82)",
                border: "0px",
                width: "68px",
                borderRadius: "8px",
                padding: "2px",
                marginTop: "16px",
              }}
              onClick={handleSave}
              disabled={
                addGift?.Description == "" ||
                addGift?.Name == "" ||
                addGift?.Price == "" ||
                (addGift?.productGuids == "" && addGift?.file == "")
              }
            >
              {editingRowId === undefined ? (
                <span>ثبت</span>
              ) : (
                <span>اپدیت</span>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="card mt-2">
        <h5> لیست هدایا</h5>
        <div className="background-dataTable">
          <ResponsiveDataList
            key={editingRowId}
            data={listGift?.items}
            columns={columns}
            filters={filters}
            className="farsi-monospace-digit"
            totalCount={listGift?.totalCount}
            rows={filters.pageSize}
            pageNumber={filters.pageNumber}
            onPageChange={({ pageNumber, pageSize }) => {
              setFilters((prev) => ({
                ...prev,
                pageNumber,
                pageSize,
              }));
            }}
            itemTemplate={(item) => (
              <ListCardAddNewGift
                item={item}
                editingRowId={editingRowId}
                handleEditClick={handleEditClick}
                DeleteProducts={DeleteProducts}
                setEditingRowId={setEditingRowId}
                setAddGift={setAddGift}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default AddNewGift;
